import adApi from '../api/adApi';
import { LOAD_AD_SUCCESS } from './actionTypes';

export function loadAd() {
    return function (dispatch) {
        return adApi.get().then(dynamicPageValue => {
            dispatch(loadAdSuccess(dynamicPageValue.page));
        }).catch(error => {
            throw (error);
        });
    };
}
export function loadAdSuccess(ad) {
    return { type: LOAD_AD_SUCCESS, ad };
}